import { Facebook, Instagram, Lock, Mail } from "lucide-react";
import { Logo } from "./Logo";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-white/5 bg-ink">
      <div className="mx-auto w-full max-w-7xl px-6 pt-16 md:px-10 md:pt-20">
        <div className="flex flex-col items-start justify-between gap-10 pb-14 md:flex-row md:items-center md:pb-20">
          <div className="flex items-center gap-4">
            <span className="text-accentlight">
              <Logo className="h-12 w-12" />
            </span>
            <div>
              <p className="font-display text-3xl tracking-wider">
                GAME<span className="text-accentlight">LENS</span>
              </p>
              <p className="text-[10px] font-semibold uppercase tracking-[0.45em] text-white/50">
                Photography
              </p>
            </div>
          </div>

          <p className="font-script text-2xl text-accentlight md:text-3xl">
            Let&rsquo;s capture your next game.
          </p>

          <div className="flex items-center gap-4">
            <a
              href="https://instagram.com/gamelensphotos"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              aria-label="GameLens Photography on Instagram"
              className="flex h-12 w-12 items-center justify-center rounded-full border border-white/10 text-white/70 transition-all duration-300 hover:border-accentlight hover:text-accentlight"
            >
              <Instagram className="h-5 w-5" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61594933152311"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              aria-label="GameLens Photography on Facebook"
              className="flex h-12 w-12 items-center justify-center rounded-full border border-white/10 text-white/70 transition-all duration-300 hover:border-accentlight hover:text-accentlight"
            >
              <Facebook className="h-5 w-5" />
            </a>
            <a
              href="mailto:GameLensPhotos@gmail.com"
              data-testid="footer-email-link"
              aria-label="Email GameLens Photography"
              className="flex h-12 w-12 items-center justify-center rounded-full border border-white/10 text-white/70 transition-all duration-300 hover:border-accentlight hover:text-accentlight"
            >
              <Mail className="h-5 w-5" />
            </a>
          </div>
        </div>

        <div className="select-none overflow-hidden" aria-hidden="true">
          <p className="bg-gradient-to-b from-white/10 to-white/[0.02] bg-clip-text text-center font-display text-[19vw] leading-[0.8] tracking-wide text-transparent md:text-[17vw]">
            GAMELENS
          </p>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-white/5 py-7 text-xs text-white/40 md:flex-row">
          <p data-testid="footer-copyright">
            © {new Date().getFullYear()} GameLens Photography. All rights reserved.
          </p>
          <p
            data-testid="footer-stripe-note"
            className="flex items-center gap-1.5 transition-colors duration-300 hover:text-white/60"
          >
            <Lock className="h-3.5 w-3.5 text-accentlight/70" />
            Payments securely processed by <span className="font-semibold text-white/60">Stripe</span>
          </p>
          <p>Baseball &bull; Action &bull; Memories</p>
        </div>
      </div>
    </footer>
  );
}
